import React, { useEffect, useState } from 'react';
import { ImageBackground, ScrollView } from 'react-native';
import {
  Button,
  Card, Colors, DataTable,
} from 'react-native-paper';
import { useSelector } from 'react-redux';

import leths_back from '../../../assets/images/leths_back.png';
import { Header } from '../../../components/common';
import { AppButton, AppText } from '../../../components/form';
import { handleWebBrowser, Logout } from '../../../config/utils';
import { API } from '../../../service/api';
import styles from './styles';

export default function ProfileStudent({ navigation }) {
  const { studentData } = useSelector((state) => state.student);
  const [userDays, setUserDays] = useState([]);
  const [days, setDays] = useState([]);
  const [userHour, setUserHour] = useState('');
  const [link, setLink] = useState('');

  useEffect(() => {
    API.post('/search/usuario_personal', {
      where: `id_usuario = '${studentData.id_usuario}'`,
    }).then((response) => {
      const tempDays = [];
      const {
        domingo, segunda, terca, quarta, quinta, sexta, sabado, horario, link: link_aula,
      } = response.data.data[0];
      if (domingo) tempDays.push(0);
      if (segunda) tempDays.push(1);
      if (terca) tempDays.push(2);
      if (quarta) tempDays.push(3);
      if (quinta) tempDays.push(4);
      if (sexta) tempDays.push(5);
      if (sabado) tempDays.push(6);
      setDays(tempDays);
      setUserHour(horario);
      setLink(link_aula);
    });
  }, []);
  useEffect(() => {
    getDates();
  }, [days]);

  const getDates = () => {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth();
    const daysMounth = new Date(year, month + 1, 0);
    const week = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'];

    function addZero(num) {
      if (num <= 9) return `0${num}`;
      return num;
    }
    const tempData = [];
    for (let i = 0; i <= daysMounth.getDate(); i++) {
      const day = new Date(year, month, i);
      if (days[0] === day.getDay() || days[1] === day.getDay()) {
        tempData.push(`${addZero(day.getDate())}/ ${addZero(day.getMonth() + 1)} - ${week[day.getDay()]}`);
      }
      if (i === daysMounth.getDate()) {
        setUserDays(tempData);
      }
    }
  };
  // const today = DateTime.now().minus({ hours: 3 });
  // const getClassText = ({ rated, data, horario_fim }) => {
  //   if (rated) {
  //     return 'Avaliado';
  //   }
  //   if (today.toFormat('yyyy-LL-dd') >= data.substring(0, 10)) {
  //     if (horario_fim <= today.toFormat('HH:mm')) {
  //       return 'Avaliar';
  //     }
  //     if (today.toFormat('yyyy-LL-dd') === data.substring(0, 10)) {
  //       return 'Assistir';
  //     }
  //     return 'Avaliar';
  //   }
  //   return 'Reagendar';
  // };

  // const getDisabledState = (rated, data, horario_inicio, horario_fim) => (
  //   rated
  //   || (getClassText({ rated, data, horario_fim }) === 'Assistir'
  //    && (horario_inicio > today.toFormat('HH:mm') || horario_fim < today.toFormat('HH:mm'))
  //   )
  // );
  // const handleAccessButton = (rated, data, link_reuniao, horario_fim, id_aula) => {
  //   if (!rated) {
  //     switch (getClassText({ rated, data, horario_fim })) {
  //       case 'Assistir':
  //         handleWebBrowser(link_reuniao);
  //         break;
  //       case 'Reagendar':
  //         navigation.navigate('Class Re-Schedule', { id_aula });
  //         break;
  //       case 'Avaliar':
  //         navigation.navigate('Evaluation', { id_aula });
  //         break;
  //       default: break;
  //     }
  //   }
  // };
  return (
    <ImageBackground source={leths_back} style={{ flex: 1 }}>
      <Header
        profilePic={studentData.foto}
        canAlterPic="Student Alter Pic"
        navigation={navigation}
        userName={studentData.nome}
      />
      <ScrollView style={styles.baseScroll}>
        <Card style={styles.cardAppointments}>
          <AppText size="bold" style={styles.textTitleCard}>Suas aulas mensais são:</AppText>
          <DataTable>
            <DataTable.Header>
              <DataTable.Title>Dia</DataTable.Title>
              <DataTable.Title>Horário</DataTable.Title>
              <DataTable.Title>Acesso</DataTable.Title>
            </DataTable.Header>
            {userDays.map((day) => (
              <DataTable.Row key={`aula-${day}`}>

                <DataTable.Cell>
                  {day}
                </DataTable.Cell>
                <DataTable.Cell>{userHour}</DataTable.Cell>
                <Button
                  style={styles.buttonTable}
                  mode="text"
                  onPress={() => handleWebBrowser(link)}
                  disabled={!link}
                >
                  {!link ? 'Aguarde' : 'Acessar'}
                </Button>
              </DataTable.Row>

            ))}
            {/* {
              !!classesData.length
                && classesData.map(({
                  id_aula, data, horario_inicio, rated, horario_fim, link_reuniao,
                }) => (
                  <DataTable.Row key={`aula-${id_aula}`}>
                    <DataTable.Cell>
                      {DateTime.fromFormat(data.substring(0, 10), 'yyyy-LL-dd').toFormat('dd/LL - ')}
                      {getDayNamesShort(DateTime.fromFormat(data.substring(0, 10), 'yyyy-LL-dd').toFormat('c') - 1)}
                    </DataTable.Cell>
                    <DataTable.Cell>{`${horario_inicio} - ${horario_fim}`}</DataTable.Cell>
                    <DataTable.Cell>
                      <Button
                        style={styles.buttonTable}
                        mode="outlined"
                        onPress={() => handleAccessButton(rated, data, link_reuniao, horario_fim, id_aula)}
                        disabled={getDisabledState(rated, data, horario_inicio, horario_fim)}
                      >
                        {getClassText({ rated, data, horario_fim })}
                      </Button>
                    </DataTable.Cell>
                  </DataTable.Row>
                ))
            } */}
          </DataTable>
        </Card>
      </ScrollView>
      <AppButton
        size="bold"
        label="SAIR"
        rippleColor={Colors.white}
        style={styles.buttonBack}
        labelStyle={styles.textBack}
        onPress={() => Logout(navigation)}
      />
    </ImageBackground>
  );
}
